// tempexp_18086-start
import type { RootState } from 'reactApp/store';
import type { LoadingState } from 'reactApp/types/commonStates';
import { createSelector } from 'reselect';

const getReferralProgramRoot = (state: RootState) => state.referralProgram;

const getLoadingState = createSelector(
    getReferralProgramRoot,
    (state): LoadingState => ({
        isLoading: state.isLoading,
        isLoaded: state.isLoaded,
    })
);
/** реферальная ссылка, которой мы можем делиться с другими */
const getLink = createSelector(getReferralProgramRoot, (state) => state.referralLink);
/** id реферальной ссылки, которой поделилилсь с нами */
const getRefId = createSelector(getReferralProgramRoot, (state) => state.ref_id);
export const ReferralProgramSelectors = { getLoadingState, getLink, getRefId };
// tempexp_18086-end
